import { useGetCertification } from "@/api/console/certifications/useGetCertification";
import { useIssueCertificate } from "@/api/console/certifications/useIssueCertificate";
import AdminContentContainer from "@/components/AdminContentContainer";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import BottomBar from "@/components/BottomBar";
import LoadingScreen from "@/components/Loading";
import { STATUS } from "@/config/progress";
import toast from "@/lib/toast";
import CompanyCard from "@/src/_components/CompanyCard";
import AnswerSheetTable from "@/src/console/(auth)/certifications/[id]/_components/AnswerSheetTable";
import CertificateIssuanceCard from "@/src/console/(auth)/certifications/[id]/_components/CertificateIssuanceCard";
import IssuedCertificateInfoCard from "@/src/console/(auth)/certifications/[id]/_components/IssuedCertificateInfoCard";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

function CertificationDetail() {
  const { id = "" } = useParams();
  const { t } = useTranslation();
  const location = useLocation();

  const { trigger, isMutating: issuingCertificate } = useIssueCertificate(id, {
    onSuccess: (data) => {
      toast.success(data.message);
      refetch();
    },
  });

  const { data, isLoading, mutate: refetch } = useGetCertification(id);

  if (isLoading || !data) {
    return <LoadingScreen />;
  }

  const { status, company, answer_sheets, issued_at } = data.data;

  const certificateAlreadyIssued = status.id === STATUS.CERTIFICATED_ISSUED;

  const breadcrumbs = [
    {
      name: t("certification"),
      href: "/console/certifications",
    },
    {
      name: certificateAlreadyIssued ? t("issued") : t("application"),
      href: location.pathname,
    },
  ];

  const handleCertificateIssuance = (issue_date: string) => {
    toast.loading(t("issue-certificate-loading"));
    trigger({ issue_date });
  };
  return (
    <>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <AdminContentContainer
        className="px-6 py-8 flex flex-col gap-8"
        bottomBar={<BottomBar backLink="/console/certifications" />}
      >
        <CompanyCard company={company} />
        <AnswerSheetTable id={id} data={answer_sheets} />
        {certificateAlreadyIssued ? (
          <IssuedCertificateInfoCard id={id} issuedAt={issued_at} />
        ) : (
          <CertificateIssuanceCard
            issuingCertificate={issuingCertificate}
            onCertificateIssue={handleCertificateIssuance}
          />
        )}
      </AdminContentContainer>
    </>
  );
}

export default CertificationDetail;
